import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { QRCodeSVG } from 'qrcode.react';
import api from '../services/api';
import { formatHandicap } from '../utils/format';
import Icon from '../components/Icon';
import './MyQR.css';

function MyQR() {
  const { user } = useAuth();
  const [copied, setCopied] = useState(false);
  // The signed key makes a scan connect instantly; without it (fetch failed)
  // the code still works, it just sends a request instead.
  const [qrKey, setQrKey] = useState(null);
  const [keyLoaded, setKeyLoaded] = useState(false);

  useEffect(() => {
    api.getQrKey()
      .then(({ key }) => setQrKey(key))
      .catch(() => setQrKey(null))
      .finally(() => setKeyLoaded(true));
  }, []);

  const qrUrl = `${window.location.origin}/connect/${user?.id}${qrKey ? `?k=${encodeURIComponent(qrKey)}` : ''}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(qrUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard can be denied (permissions, embedded webviews) — fall back
      // to selecting nothing but at least tell the user it didn't take
      window.prompt('Copy your link:', qrUrl);
    }
  };

  const handicap = formatHandicap(user?.handicap);

  return (
    <div className="myqr-page">
      <div className="myqr-header">
        <p className="eyebrow">Before you leave the course</p>
        <h1 className="myqr-title">Have them scan this.</h1>
      </div>

      <div className="myqr-card">
        <div className="myqr-strip">
          <span>Scan to connect</span>
          <span>around</span>
        </div>

        <div className="myqr-code-area">
          {!keyLoaded ? (
            <div className="myqr-code-placeholder"><div className="spinner"></div></div>
          ) : (
            <QRCodeSVG
              value={qrUrl}
              size={232}
              fgColor="#1B2620"
              bgColor="#FFFFFF"
              level="M"
              includeMargin={true}
              title={`QR code linking to ${user?.name || 'your'} around profile`}
            />
          )}
        </div>

        <div className="myqr-user-info">
          <p className="myqr-name">{user?.name}</p>
          {(handicap || user?.home_course) && (
            <div className="myqr-cells">
              {handicap && (
                <div className="myqr-cell">
                  <span className="myqr-cell-label">Handicap</span>
                  <span className="myqr-cell-big">{handicap}</span>
                </div>
              )}
              {user?.home_course && (
                <div className="myqr-cell">
                  <span className="myqr-cell-label">Home course</span>
                  <span className="myqr-cell-value">{user.home_course}</span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="myqr-actions">
        <button className="btn btn-primary btn-lg myqr-copy-btn" onClick={handleCopy}>
          <Icon name={copied ? 'check' : 'link'} size={18} />
          {copied ? 'Copied' : 'Copy link'}
        </button>
        <p className="myqr-scan-hint">Any phone camera works. Scanning connects you instantly — no request to accept.</p>
      </div>

      <div className="myqr-tip">
        <span className="myqr-tip-num">Tip</span>
        <p className="myqr-tip-text">
          Played with someone new? One scan before the parking lot and you'll never lose track of
          each other.
        </p>
      </div>
    </div>
  );
}

export default MyQR;
